export const GRAPHQL_VARIABLES = {
  BusinessLegalName: 'String',
  DoingBusinessAs: 'String',
  EIN: 'String',
  WebsiteURL: 'String',
  BusinessDescription: 'String',
  Address1: 'String',
  Address2: 'String',
  City: 'String',
  State: 'String',
  Zip: 'String',
  BankAccountNumber: 'String',
  RoutingNumber: 'String',
  BankName: 'String',
  AccountName: 'String',
  OwnersFirstName: 'String',
  OwnersLastName: 'String',
  OwnersSSN: 'String',
  OwnersEmail: 'String',
  OwnersAddress: 'String',
  OwnersAddress2: 'String',
  OwnersCity: 'String',
  OwnersState: 'String',
  OwnersZip: 'String',
  OwnersTitle: 'String'
};

export const QUERY = `
 query validateGlobalPay(
    $BusinessLegalName: String,
    $DoingBusinessAs: String,
    $EIN: String,
    $WebsiteURL: String,
    $BusinessDescription: String,
    $Address1: String,
    $Address2: String,
    $City: String,
    $State: String,
    $Zip: String,
    $BankAccountNumber: String,
    $RoutingNumber: String,
    $BankName: String,
    $AccountName: String,
    $OwnersFirstName: String,
    $OwnersLastName: String,
    $OwnersSSN: String,
    $OwnersEmail: String,
    $OwnersAddress: String,
    $OwnersAddress2: String,
    $OwnersCity: String,
    $OwnersState: String,
    $OwnersZip: String,
    $OwnersTitle: String,
    $AccountOwnershipType: String,
    $AccountType: String,
    $MerchantCategoryCode: String
 ){
    validateGlobalPay(
      BusinessLegalName:$BusinessLegalName,
      DoingBusinessAs:$DoingBusinessAs,
      EIN: $EIN,
      WebsiteURL: $WebsiteURL,
      BusinessDescription: $BusinessDescription,
      Address1: $Address1,
      Address2: $Address2,
      City: $City,
      State: $State,
      Zip: $Zip,
      BankAccountNumber: $BankAccountNumber,
      RoutingNumber: $RoutingNumber,
      BankName: $BankName,
      AccountName: $AccountName,
      OwnersFirstName: $OwnersFirstName,
      OwnersLastName: $OwnersLastName,
      OwnersSSN: $OwnersSSN,
      OwnersEmail: $OwnersEmail,
      OwnersAddress: $OwnersAddress,
      OwnersAddress2: $OwnersAddress2,
      OwnersCity: $OwnersCity,
      OwnersState: $OwnersState,
      OwnersZip: $OwnersZip,
      OwnersTitle: $OwnersTitle,
      AccountOwnershipType: $AccountOwnershipType,
      AccountType: $AccountType,
      MerchantCategoryCode: $MerchantCategoryCode
    ){
      code
      msg
      desc
    }
 }
 `;
